<template>
    <!-- Create New Multiple Bet -->
    <div class="modal fade" id="createNewMultipleBet" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header pb-1">
                    <h5 class="modal-title font-weight-bold">{{ __('bets.New Multiple') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body py-0">

                    <!-- Form -->
                    <form @submit.prevent="saveAndClose" novalidate="true">

                        <div class="card p-3 bg-light mb-2">

                            <div class="row" v-for="(selection, key) in form.selections" :key="key">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>
                                            {{ __('bets.Selection') }}
                                        </label>

                                        <input type="text" v-model="selection.name" class="form-control" :class="{ 'is-invalid': form.errors.has('selections.' + key + '.name') }" placeholder="">

                                        <has-error :form="form" :field="'selections.' + key + '.name'"></has-error>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>
                                            {{ __('bets.Odd') }}
                                        </label>

                                        <input type="number" min="1" v-model="selection.odd" class="form-control" :class="{ 'is-invalid': form.errors.has('selections.' + key + '.odd') }" placeholder="">

                                        <has-error :form="form" :field="'selections.' + key + '.odd'"></has-error>
                                    </div>
                                </div>
                                <div class="col-sm-2 align-self-center mt-2">
                                    <button type="button" @click="removeSelection(key)" class="btn btn-sm btn-default py-0" v-if="form.selections.length > 1">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <a href="javascript:;" @click="addSelection">
                                        {{ __('bets.Add Selection') }}
                                    </a>
                                </div>
                                <div class="col-sm-6">
                                    <b>
                                        {{ !isNaN(totalOdd) ? totalOdd : '---' }}
                                    </b>
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col-sm-6">
                                <!-- Description -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Description') }}</label>

                                    <input type="text" class="form-control" v-model="form.description" :class="{ 'is-invalid': form.errors.has('description') }">

                                    <has-error :form="form" field="description"></has-error>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <!-- Date -->
                                <div class="form-group">
                                    <label>{{ __('bets.Date') }} *</label>

                                    <b-form-datepicker
                                        v-model="form.date"
                                        :class="{ 'is-invalid': form.errors.has('date') }"
                                        :locale="locale"
                                        placeholder="">
                                    </b-form-datepicker>

                                    <has-error :form="form" field="date"></has-error>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Stake -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Stake') }} *</label>

                                    <currency-input
                                        :class="{ 'is-invalid': form.errors.has('stake') }"
                                        :locale="locale"
                                        :currency='currency'
                                        class="form-control font-weight-bold"
                                        v-model="form.stake"
                                    />

                                    <has-error :form="form" field="stake"></has-error>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Stake -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Result') }} *</label>

                                    <currency-input
                                        :locale="locale"
                                        :currency='currency'
                                        class="form-control font-weight-bold"
                                        v-bind:class="{'is-invalid': form.errors.has('result'), 'text-muted': form.result == 0, 'text-success': form.result > 0, 'text-danger': form.result < 0}"
                                        v-model="form.result"
                                    />

                                    <has-error :form="form" field="result"></has-error>
                                </div>
                            </div>
                        </div>

                        <!-- Justification -->
                        <div class="form-group mb-0">
                            <label class="">{{ __('bets.Justification') }}</label>

                            <textarea class="form-control" v-model="form.justification" :class="{ 'is-invalid': form.errors.has('justification') }"></textarea>

                            <div class="text-right small mt-2">
                                {{ 600 - form.justification.length > 0 ? 600 - form.justification.length : 0 }} {{ __('bets.characters left') }}
                            </div>

                            <has-error :form="form" field="justification"></has-error>
                        </div>

                        <!-- Tags -->
                        <div class="form-group">
                            <label class="">{{ __('bets.Tags') }}</label>

                            <v-select
                                taggable
                                multiple
                                push-tags
                                :class="{ 'is-invalid': form.errors.has('tag') }"
                                v-model="form.tags"
                                label="name">

                            </v-select>

                            <has-error :form="form" field="tags"></has-error>
                        </div>

                        <!-- Pending -->
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" v-model="form.pending" id="defaultPendingMulti">
                                <label class="custom-control-label" for="defaultPendingMulti">
                                    {{ __('bets.Save as a Pending Bet') }}
                                </label>
                            </div>
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">{{ __('bets.Close') }}</button>

                    <button type="button" class="btn btn-primary" @click="saveAndClose" :disabled="form.busy">
                        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="form.busy"></span>
                        <span v-if="!form.busy">{{ __('bets.Save Multiple') }}</span>
                        <span v-if="form.busy">{{ __('bets.Saving') }} ...</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Form } from 'vform'

    export default {
        props: ['locale', 'currency', 'endpointCreate'],
        data() {
            return {
                form: new Form({
                    selections: [{
                        name: null,
                        odd: null
                    }],
                    date: null,
                    stake: null,
                    result: null,
                    odd: null,
                    description: '',
                    justification: '',
                    tags: [],
                    pending: false
                }),
            }
        },
        created() {
        },
        computed: {
            totalOdd() {
                let odd = 1;
                this.form.selections.forEach(element => {
                    odd *= parseFloat(element.odd)
                })
                return parseFloat(odd).toPrecision(2)
            }
        },
        methods: {

            // Save Form and Close
            saveAndClose() {
                this.form.post(this.endpointCreate)
                    .then(result => {
                        if (result.redirect) {
                            window.location = result.redirect
                        }
                    })
            },

            // Add Selection
            addSelection() {
                this.form.selections.push({
                    name: null,
                    odd: null,
                })
            },

            removeSelection(key) {
                this.form.selections.splice(key, 1);
            }
        }
    }
</script>

<style>

</style>
